import cn from 'classnames';

import Slideout from 'components/common/Slideout';
import Text from 'components/common/Text';
import useScreenSizeConstants from 'hooks/useScreenSizeConstants';

import MealCardContainer from './MealCardContainer';

const IntroMenuSlideout = ({
  showMenuSlideout,
  setShowMenuSlideout,
  menuMeals,
  unmountSlideout,
}) => {
  const { isMobile } = useScreenSizeConstants();

  return (
    <Slideout
      id="menu-reveal-slideout"
      labelId="menu-reveal-slideout-label"
      show={showMenuSlideout}
      closeCallback={() => setShowMenuSlideout(false)}
      topBarClassname={cn({ 'border-b-0 pr-2 pl-2 pt-2 pb-0': isMobile })}
      slideoutContainerClassname={cn({
        'top-auto overflow-y-auto rounded-t-2xl px-4 pt- h-4/5': isMobile,
      })}
      unmountSlideout={unmountSlideout}
    >
      <div className="bp1:p-8">
        <Text brandStylesOverrides="h2">Your Upcoming Menu</Text>
        <Text className="mb-6 mt-2">
          Just a preview - you’ll pick your meals from the full menu after signing up.
        </Text>
        <MealCardContainer menuMeals={menuMeals} />
      </div>
    </Slideout>
  );
};

IntroMenuSlideout.propTypes = {
  showMenuSlideout: PropTypes.bool,
  setShowMenuSlideout: PropTypes.func,
  menuMeals: PropTypes.object,
  unmountSlideout: PropTypes.func.isRequired,
};

export default IntroMenuSlideout;
